/**
 * Theme helpers for the QA detail page and its cards. Colours are CSS
 * variables (`--qa-*` in index.css, with light and dark values), so inline
 * styles follow the theme toggle.
 */

/** `var(--qa-<name>)` */
export const qaVar = (name: string) => `var(--qa-${name})`;

/**
 * A see-through version of any colour, including a CSS variable — the
 * replacement for appending a hex alpha (`${V3.good}40`), which does not work
 * on `var(...)`. `alphaHex` is the old two-digit suffix as a number, e.g. 0x40.
 */
export function tint(color: string, alphaHex: number): string {
  const pct = Math.round((alphaHex / 255) * 1000) / 10;
  return `color-mix(in srgb, ${color} ${pct}%, transparent)`;
}
